import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider} from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyABg_ewBK0lGczWDz7c2EGa8kjFf3kvT1Y",
  authDomain: "eduquiz-hub.firebaseapp.com",
  projectId: "eduquiz-hub",
  storageBucket: "eduquiz-hub.firebasestorage.app",
  messagingSenderId: "1062928896699",
  appId: "1:1062928896699:web:2a0b25185d3b9c1aca8f9e"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const db = getFirestore(app);

export { auth, googleProvider, db};
export default app;
  